module.exports = __webpack_public_path__ + "media/images/services/03-2d79b0ff4d91b3b3367bcc27f579c2ae.jpg";